<div
  class="absolute inset-0 h-full w-full cursor-pointer bg-black/10"
  (click)="chat.showChat()"
  aria-hidden="true"
></div>

<section
  class="absolute inset-y-0 left-0 flex min-h-0 w-2/3 flex-col bg-surface shadow-[4px_0_16px_rgba(52,62,75,0.16)]"
  [attr.aria-label]="'chat.header.menu' | translate"
>
  <header class="flex flex-shrink-0 items-center px-4 py-2">
    <pm-button
      #closeButton
      variant="subdued"
      size="normal"
      [icon]="LucideX"
      [ariaLabel]="'chat.history.close'"
      (handleClick)="chat.showChat()"
    />
  </header>

  <pm-button
    class="mx-4 block"
    variant="subdued"
    size="normal"
    [icon]="LucidePlus"
    text="chat.history.startNewChat"
    (handleClick)="startNewChat()"
  />

  <section class="flex min-h-0 flex-1 flex-col gap-4 px-4 pb-2 pt-4">
    <div class="flex items-center justify-between gap-2">
      <pm-h3>{{ 'chat.history.previousChats' | translate }}</pm-h3>
      <pm-icon
        [icon]="LucideHistory"
        size="md"
        class="shrink-0 text-content-subdued"
      />
    </div>

    @if (isLoadingFirstPage()) {
    <div
      class="flex flex-1 items-center justify-center"
      role="status"
      [attr.aria-label]="'chat.history.loading' | translate"
    >
      <pm-icon
        [icon]="LucideLoaderCircle"
        size="md"
        class="animate-spin text-content-subdued"
      />
    </div>
    } @else if (hasAnySession()) {
    <pm-form-input-search
      size="sm"
      [ngModel]="searchValue()"
      (ngModelChange)="onSearch($event ?? '')"
      placeholder="chat.history.searchPlaceholder"
    />
    <div
      class="min-h-0 flex-1 overflow-y-auto [scrollbar-color:var(--border-color)_transparent] [scrollbar-width:thin] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:w-1.5"
    >
      <ul class="m-0 list-none p-0">
        @for (session of chatHistory.filteredSessions(); track session.id) {
        <li class="group flex items-center gap-2 py-2.5">
          <span
            class="shrink-0 text-lg leading-none text-content-interactive-default"
            aria-hidden="true"
            >&bull;</span
          >
          <button
            type="button"
            safeButtonUsage
            class="w-full text-start"
            [attr.aria-label]="session.title"
            (click)="onLoadSession(session.id)"
          >
            <div class="text-sm font-medium text-content-title">
              {{ session.title }}
            </div>
            <div class="text-xs font-normal text-content-subdued">
              {{ dateUtils.formatDateTimeBasedOnLanguage(session.updatedAt) }}
            </div>
          </button>
          <pm-button
            class="shrink-0 opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100 group-focus-within:opacity-100"
            variant="subdued"
            size="normal"
            [icon]="LucideTrash2"
            [ariaLabel]="'chat.menu.deleteChat'"
            (handleClick)="onDelete(session.id, $event)"
          />
        </li>
        } @empty {
        <li class="py-2.5 text-xs leading-snug text-content-subdued">
          {{ 'chat.history.noResult' | translate }}
        </li>
        } @if (isLoadingMore()) {
        <li
          class="flex justify-center py-2.5"
          role="status"
          [attr.aria-label]="'chat.history.loading' | translate"
        >
          <pm-icon
            [icon]="LucideLoaderCircle"
            size="sm"
            class="animate-spin text-content-subdued"
          />
        </li>
        } @if (chatHistory.hasMore()) {
        <li #sentinel aria-hidden="true"></li>
        }
      </ul>
    </div>
    } @else {
    <p class="mt-2 text-xs leading-snug text-content-subdued">
      {{ 'chat.history.empty' | translate }}
    </p>
    }
  </section>
</section>
